import React from "react";
import { CCard, CCol } from "@coreui/react";
import { useLocation } from "react-router-dom";

const TheNav = (props) => {
  // const step = Number(props.step);
  const pathParam = useLocation().pathname.substr(-1, 1);

  return (
    <>
      <nav>
        <CCol>
          <CCard>
            <ul id="nav">
              {/* <li className={step === 1 ? "active" : ""}>사전안내</li>
              <li className={step === 2 ? "active" : ""}>약관동의</li>
              <li className={step === 3 ? "active" : ""}>정보입력</li>
              <li className={step === 4 ? "active" : ""}>서류작성</li>
              <li className={step === 5 ? "active" : ""}>추가서류</li>
              <li className={step === 6 ? "active" : ""}>원본서류</li> */}
              <li className={pathParam === "1" ? "active" : ""}>사전안내</li>
              <li className={pathParam === "2" ? "active" : ""}>약관동의</li>
              <li className={pathParam === "3" ? "active" : ""}>정보입력</li>
              <li className={pathParam === "4" || pathParam === "5" ? "active" : ""}>서류작성</li>
              <li className={pathParam === "6" ? "active" : ""}>추가서류</li>
              <li className={pathParam === "7" ? "active" : ""}>원본서류</li>
            </ul>
          </CCard>
        </CCol>
      </nav>
    </>
  );
};

export default TheNav;
